"use client"

import { useEffect, useState } from 'react'

const HubSpot = ({ nonce }) => {
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        const loadScript = () => {
            if (!loaded) {
                const script = document.createElement('script')
                script.src = "//js-eu1.hs-scripts.com/25897301.js"
                script.async = true
                script.defer = true
                script.nonce = { nonce }
                document.body.appendChild(script)
                setLoaded(true)
            }
        }

        window.addEventListener('scroll', loadScript, { once: true })
        window.addEventListener('mousemove', loadScript, { once: true })

        return () => {
            window.removeEventListener('scroll', loadScript)
            window.removeEventListener('mousemove', loadScript)
        }
    }, [loaded])

    return null
}

export default HubSpot
